export default "__VITE_PUBLIC_ASSET__25b62554__"